import { ed } from "./tokens";

interface InlineBarProps {
  value: number;
  prior?: number | null;
  max: number;
  width?: number;
}

/**
 * A word-sized bar for table cells: this period in ink, last period as a
 * tick. Lets a column of numbers be scanned for shape.
 */
export function InlineBar({ value, prior, max, width = 56 }: InlineBarProps) {
  const x = (v: number) => (max > 0 ? Math.min(width, (v / max) * width) : 0);
  return (
    <svg
      width={width}
      height={10}
      viewBox={`0 0 ${width} 10`}
      aria-hidden
      style={{ display: "inline-block", verticalAlign: "middle" }}
    >
      <rect x={0} y={4} width={width} height={2} fill={ed.grid} />
      <rect x={0} y={2} width={x(value)} height={6} fill={ed.ink} />
      {prior !== undefined && prior !== null && (
        <line x1={x(prior)} x2={x(prior)} y1={0} y2={10} stroke={ed.ink3} strokeWidth={1.5} />
      )}
    </svg>
  );
}
